import { Button, Divider, Form, Switch, Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import Sticky from 'react-sticky-el';
import parse from 'html-react-parser';
import GlobalService from '../../../../services/Global.service';
import moment from 'moment';
import classNames from 'classnames';
import ModalConfirm from '../../../../components/Shared/modal/confirm';
import { useRef } from 'react';

const StepPreview = ({ forms, ...props }) => {
    const { t } = useTranslation(['translation', 'consent']);

    const [previewLang, setPreviewLang] = useState('TH');
    const [logo, setLogo] = useState('');
    const [openConfirm, setOpenConfirm] = useState(false);

    const {
        cctvPolicy,
        cctvIntroductionLawfulBasis,
        cctvPersonalDataCollect,
        cctvReasonCollectedData,
        cctvTransferPersonalData,
        cctvRetainPersonalData,
        cctvDataSubjectRight,
        cctvPolicyChange,
    } = forms;

    const _cctvPolicy = {
        ...props?.previewData.cctvPolicy,
        ...cctvPolicy.getFieldsValue(),
    };
    const _cctvIntroductionLawfulBasis =
        cctvIntroductionLawfulBasis.getFieldsValue();
    const _cctvPersonalDataCollect = cctvPersonalDataCollect.getFieldsValue();
    const _cctvReasonCollectedData = cctvReasonCollectedData.getFieldsValue();
    const _cctvTransferPersonalData = cctvTransferPersonalData.getFieldsValue();
    const _cctvRetainPersonalData = cctvRetainPersonalData.getFieldsValue();
    const _cctvDataSubjectRight = cctvDataSubjectRight.getFieldsValue();
    const _cctvPolicyChange = cctvPolicyChange.getFieldsValue();

    // Cheked
    // step 2
    const cctvIntroductionIsDisplay = Form.useWatch(
        'cctvIntroductionIsDisplay',
        cctvIntroductionLawfulBasis
    );
    const cctvLawfulBasisIsDisplay = Form.useWatch(
        'cctvLawfulBasisIsDisplay',
        cctvIntroductionLawfulBasis
    );
    //  step 3
    const cctvPersonalDataIsDisplay = Form.useWatch(
        'cctvPersonalDataIsDisplay',
        cctvPersonalDataCollect
    );
    const cctvSourceIsDisplay = Form.useWatch(
        'cctvSourceIsDisplay',
        cctvPersonalDataCollect
    );
    // step 4
    const cctvPurposeIsDisplay = Form.useWatch(
        'cctvPurposeIsDisplay',
        cctvReasonCollectedData
    );
    // step 5
    const cctvDisclosureIsDisplay = Form.useWatch(
        'cctvDisclosureIsDisplay',
        cctvTransferPersonalData
    );
    const cctvInternationalIsDisplay = Form.useWatch(
        'cctvInternationalIsDisplay',
        cctvTransferPersonalData
    );
    // step 6
    const cctvRetentionIsDisplay = Form.useWatch(
        'cctvRetentionIsDisplay',
        cctvRetainPersonalData
    );
    const cctvSecurityIsDisplay = Form.useWatch(
        'cctvSecurityIsDisplay',
        cctvRetainPersonalData
    );
    //  step 7
    const cctvDataSubjectRightIsDisplay = Form.useWatch(
        'cctvDataSubjectRightIsDisplay',
        cctvDataSubjectRight
    );
    // step 8
    const cctvChangeIsDisplay = Form.useWatch(
        'cctvChangeIsDisplay',
        cctvPolicyChange
    );
    const cctvDataControllerIsDisplay = Form.useWatch(
        'cctvDataControllerIsDisplay',
        cctvPolicyChange
    );
    const cctvDataProtectionIsDisplay = Form.useWatch(
        'cctvDataProtectionIsDisplay',
        cctvPolicyChange
    );

    useEffect(() => {
        const getImage = async () => {
            try {
                const { data } = await GlobalService.getImage(
                    _cctvPolicy?.cctvCompanyLogoId
                );
                if (data.resultData?.imageId) {
                    setLogo(
                        `data:image/png;base64,${data.resultData?.imageId}`
                    );
                }
            } catch (error) {
                console.log(error);
            }
        };
        if (_cctvPolicy?.cctvCompanyLogoId) getImage();
        else setLogo('');
    }, [_cctvPolicy?.cctvCompanyLogoId]);

    const statusSwitch = (isPublished, isPublishedVersion) => {
        return (
            <div className="flex items-center space-x-2 mt-1">
                <div
                    className={classNames(
                        'rounded-full w-max px-3 text-xs font-medium',
                        {
                            'text-[#9A9A9A]': !isPublished,
                            'text-[#4ACE8F]': isPublished,
                        }
                    )}
                    style={
                        isPublished
                            ? {
                                  border: '1px solid #4ACE8F',
                              }
                            : {
                                  border: '1px solid #9A9A9A',
                              }
                    }
                >
                    {isPublished ? 'Published' : 'Draft'} {isPublishedVersion}
                </div>
                <span className="text-[#65707A]">
                    {isPublished &&
                        `${t('Last published', { ns: 'consent' })} : ` +
                            `${
                                props?.previewData?.cctvPolicy?.publishDate !==
                                undefined
                                    ? props?.previewData?.cctvPolicy
                                          ?.publishDate
                                    : '-'
                            }`}
                </span>
            </div>
        );
    };

    let cctvPolicyDataSubjectType = [];

    const dsTypeGroup = _cctvPolicy?.cctvPolicyDataSubjectType;

    if (dsTypeGroup) {
        const dsTypefilter = props?.dsType.filter((ds) =>
            dsTypeGroup.includes(ds.id)
        );
        cctvPolicyDataSubjectType = dsTypefilter.map((ds) => {
            return {
                dataSubjectId: ds.id,
                dataSubjectNameTh: ds.nameEn,
                dataSubjectNameEn: ds.nameTh,
            };
        });
    }

    let isChange = false;
    let isPublished = false;
    const version = _cctvPolicy?.version || '0000.0';
    let isPublishedVersion = version;

    const parts = version?.split('.');

    const numberBehindDecimal = parseInt(parts[1]);
    const numberVersion = parseInt(parts[0]);
    if (parts && parts.length > 0) {
        if (numberVersion > 0) {
            isPublished = true;
            isPublishedVersion = parts[0] + '.0';
            if (numberBehindDecimal > 0) {
                isChange = true;
                isPublishedVersion = parts[0] + '.0';
            }
        }
    }

    const getNextVersion = () => {
        let item = '';
        let version = _cctvPolicy?.latestPublishVersion;
        for (let index = 0; index <= 3; index++) {
            if (version?.split('.')[0][index] !== '0') {
                item = version
                    ?.split('.')[0]
                    ?.slice(index, version?.split('.')[0]?.length);
                break;
            }
        }
        item = String(Number(item) + 1);
        switch (item?.length) {
            case 1:
                item = '000'.concat(`${item}.0`);
                break;
            case 2:
                item = '00'.concat(`${item}.0`);
                break;
            case 3:
                item = '0'.concat(`${item}.0`);
                break;
            default:
                item = item.concat(`.0`);
                break;
        }
        return item;
    };

    const ref = useRef();

    return (
        <Form name="preview">
            <Sticky stickyClassName="bg-white p-4 w-full z-50">
                <div className="flex px-4">
                    <div className="flex-1">
                        <div className="text-2xl font-semibold">
                            {t('policy.des8')}
                        </div>
                        {statusSwitch(isPublished, isPublishedVersion)}
                    </div>
                    <div className="flex space-x-4">
                        {isChange && (
                            <div className="text-xs text-right text-[#65707A]">
                                <div className="mb-1">
                                    {`${t('LastUpdate')} : ` +
                                        `${_cctvPolicy?.updateDate || '-'}`}
                                </div>
                                <div>{`${t('Version')} : ${version}`}</div>
                                <div className="text-[#F0536F]">
                                    <span className="text-xl align-middle">
                                        &bull;
                                    </span>{' '}
                                    {t('Consent.DataChanged')}
                                </div>
                            </div>
                        )}
                        {((numberVersion === 0 && numberBehindDecimal > 0) ||
                            (numberVersion > 0 &&
                                numberBehindDecimal === 0)) && (
                            <div className="text-xs mt-[9px] text-[#65707A]">
                                <div className="mb-1">
                                    {`${t('LastUpdate')} : ` +
                                        `${_cctvPolicy?.updateDate || '-'}`}
                                </div>
                            </div>
                        )}
                        <Button
                            type="default"
                            size="large"
                            loading={props.loadingSaveDraft}
                            onClick={props.saveDraft}
                            className="border-purple text-purple px-6"
                        >
                            {t('Save Draft')}
                        </Button>
                        <Button
                            loading={props.loading_}
                            type="primary"
                            size="large"
                            onClick={() => setOpenConfirm(true)}
                        >
                            {t('Save And Publish')}
                        </Button>
                        <button ref={ref} className="hidden" type="submit" />
                    </div>
                </div>
            </Sticky>

            <div className="px-4">
                <Divider className="mb-1" />
                <div className={`py-4 flex space-x-2 text-tiny`}>
                    <span
                        style={{ borderRight: '1px solid #DBDBDB' }}
                        onClick={() => {
                            setPreviewLang('TH');
                        }}
                        className={`${
                            previewLang === 'TH'
                                ? 'text-[#1890FF] font-semibold'
                                : ''
                        } cursor-pointer hover:opacity-80 pr-2`}
                    >
                        {t('policy.th')}
                    </span>
                    <span
                        onClick={() => {
                            setPreviewLang('EN');
                        }}
                        className={`${
                            previewLang === 'EN'
                                ? 'text-[#1890FF] font-semibold'
                                : ''
                        } cursor-pointer hover:opacity-80`}
                    >
                        {t('policy.en')}
                    </span>
                </div>
                <div className="space-y-4">
                    {/* Step 1 */}
                    <div>
                        <div
                            className="flex px-4 py-1 items-center mb-4"
                            style={{ background: '#F4F6FC' }}
                        >
                            <div className="flex-1 text-purple-PHX font-semibold">
                                {previewLang === 'EN'
                                    ? 'Define the policy name and organization information'
                                    : 'กำหนดชื่อนโยบายและข้อมูลองค์กร'}
                            </div>
                            <div
                                className="mt-1 hover:opacity-80 cursor-pointer"
                                onClick={() => {
                                    props.goToStep(1);
                                }}
                            >
                                {EditIcon}
                            </div>
                        </div>
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717]">
                                {previewLang === 'EN'
                                    ? 'Name of CCTV Policy'
                                    : 'ชื่อนโยบายความเป็นส่วนตัวสำหรับกล้องวงจรปิด'}
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {previewLang === 'EN'
                                    ? _cctvPolicy?.cctvPolicyNameEn || '-'
                                    : _cctvPolicy?.cctvPolicyNameTh || '-'}
                            </div>
                            <Divider dashed className="border-t-2" />
                            <div className="font-semibold text-[#171717]">
                                {previewLang === 'EN'
                                    ? 'Updated as of'
                                    : 'ฉบับ ณ วันที่'}
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {_cctvPolicy?.cctvEffectiveDate
                                    ? moment(
                                          _cctvPolicy?.cctvEffectiveDate
                                      ).format('DD/MM/YYYY')
                                    : '-'}
                            </div>
                            <Divider dashed className="border-t-2" />
                            <div className="font-semibold text-[#171717]">
                                {previewLang === 'EN'
                                    ? 'Organization name (or Owner Name)'
                                    : 'ชื่อองค์กร (หรือชื่อบุคคลเจ้าของ)'}
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {previewLang === 'EN'
                                    ? _cctvPolicy?.cctvCompanyNameEn || '-'
                                    : _cctvPolicy?.cctvCompanyNameTh || '-'}
                            </div>
                            <Divider dashed className="border-t-2" />
                            <div className="font-semibold text-[#171717]">
                                {previewLang === 'EN'
                                    ? 'Company Logo'
                                    : 'โลโก้องค์กร'}
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {logo ? (
                                    // eslint-disable-next-line jsx-a11y/img-redundant-alt
                                    <img
                                        className="h-16 w-auto rounded-lg object-cover"
                                        style={{
                                            border: '1px solid #DBDBDB',
                                        }}
                                        src={logo}
                                        alt="image"
                                    />
                                ) : (
                                    svgNoImage
                                )}
                            </div>
                            <Divider dashed className="border-t-2" />
                            <div className="font-semibold text-[#171717]">
                                {previewLang === 'EN'
                                    ? 'What types of data subjects does this policy apply to'
                                    : 'นโยบายนี้ใช้กับเจ้าของข้อมูลประเภทใด'}
                            </div>
                            <div className="py-2 text-[#65707A]">
                                {cctvPolicyDataSubjectType
                                    ?.map((ds) =>
                                        previewLang === 'EN'
                                            ? ds.dataSubjectNameEn
                                            : ds.dataSubjectNameTh
                                    )
                                    .join(', ') || '-'}
                            </div>
                        </div>
                    </div>
                    {/* Step 2 */}
                    <div>
                        <div
                            className="flex px-4 py-1 items-center mb-4"
                            style={{ background: '#F4F6FC' }}
                        >
                            <div className="flex-1 text-purple-PHX font-semibold">
                                {previewLang === 'EN'
                                    ? 'Introduction and Lawful Basis'
                                    : 'บทนำและฐานกฎหมาย'}
                            </div>
                            <div
                                className="mt-1 hover:opacity-80 cursor-pointer"
                                onClick={() => {
                                    props.goToStep(2);
                                }}
                            >
                                {EditIcon}
                            </div>
                        </div>
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717] flex">
                                <div className="w-full">
                                    {previewLang === 'EN'
                                        ? _cctvIntroductionLawfulBasis?.cctvIntroductionTitleEn ||
                                          '-'
                                        : _cctvIntroductionLawfulBasis?.cctvIntroductionTitleTh ||
                                          '-'}
                                </div>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                    <div className="font-semibold">
                                        {previewLang === 'EN'
                                            ? 'Show'
                                            : 'แสดงข้อมูล'}
                                    </div>
                                    <Switch
                                        checked={cctvIntroductionIsDisplay}
                                        onChange={(checked) => {
                                            cctvIntroductionLawfulBasis.setFieldValue(
                                                'cctvIntroductionIsDisplay',
                                                checked
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="py-2 whitespace-pre-wrap text-[#65707A]">
                                {parse(
                                    `${
                                        previewLang === 'EN'
                                            ? _cctvIntroductionLawfulBasis?.cctvIntroductionContentEn ||
                                              '-'
                                            : _cctvIntroductionLawfulBasis?.cctvIntroductionContentTh ||
                                              '-'
                                    }`
                                )}
                            </div>
                            <Divider dashed className="border-t-2" />
                            <div className="font-semibold text-[#171717] flex">
                                <div className="w-full">
                                    {previewLang === 'EN'
                                        ? _cctvIntroductionLawfulBasis?.cctvLawfulBasisTitleEn ||
                                          '-'
                                        : _cctvIntroductionLawfulBasis?.cctvLawfulBasisTitleTh ||
                                          '-'}
                                </div>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                    <div className="font-semibold">
                                        {previewLang === 'EN'
                                            ? 'Show'
                                            : 'แสดงข้อมูล'}
                                    </div>
                                    <Switch
                                        checked={cctvLawfulBasisIsDisplay}
                                        onChange={(checked) => {
                                            cctvIntroductionLawfulBasis.setFieldValue(
                                                'cctvLawfulBasisIsDisplay',
                                                checked
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="py-2 whitespace-pre-wrap text-[#65707A]">
                                {parse(
                                    `${
                                        previewLang === 'EN'
                                            ? _cctvIntroductionLawfulBasis?.cctvLawfulBasisContentEn ||
                                              '-'
                                            : _cctvIntroductionLawfulBasis?.cctvLawfulBasisContentTh ||
                                              '-'
                                    }`
                                )}
                            </div>
                        </div>
                    </div>
                    {/* Step 3 */}
                    <div>
                        <div
                            className="flex px-4 py-1 items-center mb-4"
                            style={{ background: '#F4F6FC' }}
                        >
                            <div className="flex-1 text-purple-PHX font-semibold">
                                {previewLang === 'EN'
                                    ? 'Personal data collected and used'
                                    : 'ข้อมูลส่วนบุคคลที่เก็บรวบรวม และแหล่งที่มา'}
                            </div>
                            <div
                                className="mt-1 hover:opacity-80 cursor-pointer"
                                onClick={() => {
                                    props.goToStep(3);
                                }}
                            >
                                {EditIcon}
                            </div>
                        </div>
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717] flex">
                                <div className="w-full">
                                    {previewLang === 'EN'
                                        ? _cctvPersonalDataCollect?.cctvPersonalDataTitleEn ||
                                          '-'
                                        : _cctvPersonalDataCollect?.cctvPersonalDataTitleTh ||
                                          '-'}
                                </div>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                    <div className="font-semibold">
                                        {previewLang === 'EN'
                                            ? 'Show'
                                            : 'แสดงข้อมูล'}
                                    </div>
                                    <Switch
                                        checked={cctvPersonalDataIsDisplay}
                                        onChange={(checked) => {
                                            cctvPersonalDataCollect.setFieldValue(
                                                'cctvPersonalDataIsDisplay',
                                                checked
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="py-2 whitespace-pre-wrap text-[#65707A]">
                                {parse(
                                    `${
                                        previewLang === 'EN'
                                            ? _cctvPersonalDataCollect?.cctvPersonalDataContentEn ||
                                              '-'
                                            : _cctvPersonalDataCollect?.cctvPersonalDataContentTh ||
                                              '-'
                                    }`
                                )}
                            </div>
                            <Divider dashed className="border-t-2" />
                            <div className="font-semibold text-[#171717] flex">
                                <div className="w-full">
                                    {previewLang === 'EN'
                                        ? _cctvPersonalDataCollect?.cctvSourceTitleEn ||
                                          '-'
                                        : _cctvPersonalDataCollect?.cctvSourceTitleTh ||
                                          '-'}
                                </div>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                    <div className="font-semibold">
                                        {previewLang === 'EN'
                                            ? 'Show'
                                            : 'แสดงข้อมูล'}
                                    </div>
                                    <Switch
                                        checked={cctvSourceIsDisplay}
                                        onChange={(checked) => {
                                            cctvPersonalDataCollect.setFieldValue(
                                                'cctvSourceIsDisplay',
                                                checked
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="py-2 whitespace-pre-wrap text-[#65707A]">
                                {parse(
                                    `${
                                        previewLang === 'EN'
                                            ? _cctvPersonalDataCollect?.cctvSourceContentEn ||
                                              '-'
                                            : _cctvPersonalDataCollect?.cctvSourceContentTh ||
                                              '-'
                                    }`
                                )}
                            </div>
                        </div>
                    </div>
                    {/* Step4 */}
                    <div>
                        <div
                            className="flex px-4 py-1 items-center mb-4"
                            style={{ background: '#F4F6FC' }}
                        >
                            <div className="flex-1 text-purple-PHX font-semibold">
                                {previewLang === 'EN'
                                    ? 'Reason for collected data'
                                    : 'เหตุผลในการเก็บรวบรวมข้อมูล'}
                            </div>
                            <div
                                className="mt-1 hover:opacity-80 cursor-pointer"
                                onClick={() => {
                                    props.goToStep(4);
                                }}
                            >
                                {EditIcon}
                            </div>
                        </div>
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717] flex">
                                <div className="w-full">
                                    {previewLang === 'EN'
                                        ? _cctvReasonCollectedData?.cctvPurposeTitleEn ||
                                          '-'
                                        : _cctvReasonCollectedData?.cctvPurposeTitleTh ||
                                          '-'}
                                </div>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                    <div className="font-semibold">
                                        {previewLang === 'EN'
                                            ? 'Show'
                                            : 'แสดงข้อมูล'}
                                    </div>
                                    <Switch
                                        checked={cctvPurposeIsDisplay}
                                        onChange={(checked) => {
                                            cctvReasonCollectedData.setFieldValue(
                                                'cctvPurposeIsDisplay',
                                                checked
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="py-2 whitespace-pre-wrap text-[#65707A]">
                                {parse(
                                    `${
                                        previewLang === 'EN'
                                            ? _cctvReasonCollectedData?.cctvPurposeContentEn ||
                                              '-'
                                            : _cctvReasonCollectedData?.cctvPurposeContentTh ||
                                              '-'
                                    }`
                                )}
                            </div>
                        </div>
                    </div>
                    {/* Step5 */}
                    <div>
                        <div
                            className="flex px-4 py-1 items-center mb-4"
                            style={{ background: '#F4F6FC' }}
                        >
                            <div className="flex-1 text-purple-PHX font-semibold">
                                {previewLang === 'EN'
                                    ? 'Who we will disclose or transfer personal data'
                                    : 'บุคคลใดที่เราจะเปิดเผยหรือโอนข้อมูลส่วนบุคคล'}
                            </div>
                            <div
                                className="mt-1 hover:opacity-80 cursor-pointer"
                                onClick={() => {
                                    props.goToStep(5);
                                }}
                            >
                                {EditIcon}
                            </div>
                        </div>
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717] flex">
                                <div className="w-full">
                                    {previewLang === 'EN'
                                        ? _cctvTransferPersonalData?.cctvDisclosureTitleEn ||
                                          '-'
                                        : _cctvTransferPersonalData?.cctvDisclosureTitleTh ||
                                          '-'}
                                </div>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                    <div className="font-semibold">
                                        {previewLang === 'EN'
                                            ? 'Show'
                                            : 'แสดงข้อมูล'}
                                    </div>
                                    <Switch
                                        checked={cctvDisclosureIsDisplay}
                                        onChange={(checked) => {
                                            cctvTransferPersonalData.setFieldValue(
                                                'cctvDisclosureIsDisplay',
                                                checked
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="py-2 whitespace-pre-wrap text-[#65707A]">
                                {parse(
                                    `${
                                        previewLang === 'EN'
                                            ? _cctvTransferPersonalData?.cctvDisclosureContentEn ||
                                              '-'
                                            : _cctvTransferPersonalData?.cctvDisclosureContentTh ||
                                              '-'
                                    }`
                                )}
                            </div>
                        </div>
                        <Divider dashed className="border-t-2" />
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717] flex">
                                <div className="w-full">
                                    {previewLang === 'EN'
                                        ? _cctvTransferPersonalData?.cctvInternationalTitleEn ||
                                          '-'
                                        : _cctvTransferPersonalData?.cctvInternationalTitleTh ||
                                          '-'}
                                </div>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                    <div className="font-semibold">
                                        {previewLang === 'EN'
                                            ? 'Show'
                                            : 'แสดงข้อมูล'}
                                    </div>
                                    <Switch
                                        checked={cctvInternationalIsDisplay}
                                        onChange={(checked) => {
                                            cctvTransferPersonalData.setFieldValue(
                                                'cctvInternationalIsDisplay',
                                                checked
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="py-2 whitespace-pre-wrap text-[#65707A]">
                                {parse(
                                    `${
                                        previewLang === 'EN'
                                            ? _cctvTransferPersonalData?.cctvInternationalContentEn ||
                                              '-'
                                            : _cctvTransferPersonalData?.cctvInternationalContentTh ||
                                              '-'
                                    }`
                                )}
                            </div>
                        </div>
                    </div>
                    {/* Step6 */}
                    <div>
                        <div
                            className="flex px-4 py-1 items-center mb-4"
                            style={{ background: '#F4F6FC' }}
                        >
                            <div className="flex-1 text-purple-PHX font-semibold">
                                {previewLang === 'EN'
                                    ? 'How long and how we retain personal data?'
                                    : 'รักษาข้อมูลส่วนบุคคลไว้นานเท่าใดและเก็บรักษาข้อมูลอย่างไร'}
                            </div>
                            <div
                                className="mt-1 hover:opacity-80 cursor-pointer"
                                onClick={() => {
                                    props.goToStep(6);
                                }}
                            >
                                {EditIcon}
                            </div>
                        </div>
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717] flex">
                                <div className="w-full">
                                    {previewLang === 'EN'
                                        ? _cctvRetainPersonalData?.cctvRetentionTitleEn ||
                                          '-'
                                        : _cctvRetainPersonalData?.cctvRetentionTitleTh ||
                                          '-'}
                                </div>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                    <div className="font-semibold">
                                        {previewLang === 'EN'
                                            ? 'Show'
                                            : 'แสดงข้อมูล'}
                                    </div>
                                    <Switch
                                        checked={cctvRetentionIsDisplay}
                                        onChange={(checked) => {
                                            cctvRetainPersonalData.setFieldValue(
                                                'cctvRetentionIsDisplay',
                                                checked
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="py-2 whitespace-pre-wrap text-[#65707A]">
                                {parse(
                                    `${
                                        previewLang === 'EN'
                                            ? _cctvRetainPersonalData?.cctvRetentionContentEn ||
                                              '-'
                                            : _cctvRetainPersonalData?.cctvRetentionContentTh ||
                                              '-'
                                    }`
                                )}
                            </div>
                        </div>
                        <Divider dashed className="border-t-2" />
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717] flex">
                                <div className="w-full">
                                    {previewLang === 'EN'
                                        ? _cctvRetainPersonalData?.cctvSecurityTitleEn ||
                                          '-'
                                        : _cctvRetainPersonalData?.cctvSecurityTitleTh ||
                                          '-'}
                                </div>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                    <div className="font-semibold">
                                        {previewLang === 'EN'
                                            ? 'Show'
                                            : 'แสดงข้อมูล'}
                                    </div>
                                    <Switch
                                        checked={cctvSecurityIsDisplay}
                                        onChange={(checked) => {
                                            cctvRetainPersonalData.setFieldValue(
                                                'cctvSecurityIsDisplay',
                                                checked
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="py-2 whitespace-pre-wrap text-[#65707A]">
                                {parse(
                                    `${
                                        previewLang === 'EN'
                                            ? _cctvRetainPersonalData?.cctvSecurityContentEn ||
                                              '-'
                                            : _cctvRetainPersonalData?.cctvSecurityContentTh ||
                                              '-'
                                    }`
                                )}
                            </div>
                        </div>
                    </div>
                    {/* Step7 */}
                    <div>
                        <div
                            className="flex px-4 py-1 items-center mb-4"
                            style={{ background: '#F4F6FC' }}
                        >
                            <div className="flex-1 text-purple-PHX font-semibold">
                                {previewLang === 'EN'
                                    ? 'Reason for collected data'
                                    : 'เหตุผลในการเก็บรวบรวมข้อมูล'}
                            </div>
                            <div
                                className="mt-1 hover:opacity-80 cursor-pointer"
                                onClick={() => {
                                    props.goToStep(7);
                                }}
                            >
                                {EditIcon}
                            </div>
                        </div>
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717] flex">
                                <div className="w-full">
                                    {previewLang === 'EN'
                                        ? _cctvDataSubjectRight?.cctvDataSubjectRightTitleEn ||
                                          '-'
                                        : _cctvDataSubjectRight?.cctvDataSubjectRightTitleTh ||
                                          '-'}
                                </div>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                    <div className="font-semibold">
                                        {previewLang === 'EN'
                                            ? 'Show'
                                            : 'แสดงข้อมูล'}
                                    </div>
                                    <Switch
                                        checked={cctvDataSubjectRightIsDisplay}
                                        onChange={(checked) => {
                                            cctvDataSubjectRight.setFieldValue(
                                                'cctvDataSubjectRightIsDisplay',
                                                checked
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="py-2 whitespace-pre-wrap text-[#65707A]">
                                {parse(
                                    `${
                                        previewLang === 'EN'
                                            ? _cctvDataSubjectRight?.cctvDataSubjectRightContentEn ||
                                              '-'
                                            : _cctvDataSubjectRight?.cctvDataSubjectRightContentTh ||
                                              '-'
                                    }`
                                )}
                            </div>
                        </div>
                    </div>
                    {/* Step8 */}
                    <div>
                        <div
                            className="flex px-4 py-1 items-center mb-4"
                            style={{ background: '#F4F6FC' }}
                        >
                            <div className="flex-1 text-purple-PHX font-semibold">
                                {previewLang === 'EN'
                                    ? 'Policy change and contact channels'
                                    : 'การเปลี่ยนแปลงนโยบาย และช่องทางการติดต่อ'}
                            </div>
                            <div
                                className="mt-1 hover:opacity-80 cursor-pointer"
                                onClick={() => {
                                    props.goToStep(8);
                                }}
                            >
                                {EditIcon}
                            </div>
                        </div>
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717] flex">
                                <div className="w-full">
                                    {previewLang === 'EN'
                                        ? _cctvPolicyChange?.cctvChangeTitleEn ||
                                          '-'
                                        : _cctvPolicyChange?.cctvChangeTitleTh ||
                                          '-'}
                                </div>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                    <div className="font-semibold">
                                        {previewLang === 'EN'
                                            ? 'Show'
                                            : 'แสดงข้อมูล'}
                                    </div>
                                    <Switch
                                        checked={cctvChangeIsDisplay}
                                        onChange={(checked) => {
                                            cctvPolicyChange.setFieldValue(
                                                'cctvChangeIsDisplay',
                                                checked
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="whitespace-pre-wrap text-[#65707A]">
                                {parse(
                                    `${
                                        previewLang === 'EN'
                                            ? _cctvPolicyChange?.cctvChangeContentEn ||
                                              '-'
                                            : _cctvPolicyChange?.cctvChangeContentTh ||
                                              '-'
                                    }`
                                )}
                            </div>
                        </div>
                        <Divider dashed className="border-t-2" />
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717] flex">
                                <div className="w-full">
                                    {previewLang === 'EN'
                                        ? _cctvPolicyChange?.cctvDataControllerTitleEn ||
                                          '-'
                                        : _cctvPolicyChange?.cctvDataControllerTitleTh ||
                                          '-'}
                                </div>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                    <div className="font-semibold">
                                        {previewLang === 'EN'
                                            ? 'Show'
                                            : 'แสดงข้อมูล'}
                                    </div>
                                    <Switch
                                        checked={cctvDataControllerIsDisplay}
                                        onChange={(checked) => {
                                            cctvPolicyChange.setFieldValue(
                                                'cctvDataControllerIsDisplay',
                                                checked
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="whitespace-pre-wrap text-[#65707A]">
                                {parse(
                                    `${
                                        previewLang === 'EN'
                                            ? _cctvPolicyChange?.cctvDataControllerContentEn ||
                                              '-'
                                            : _cctvPolicyChange?.cctvDataControllerContentTh ||
                                              '-'
                                    }`
                                )}
                            </div>
                        </div>
                        <Divider dashed className="border-t-2" />
                        <div className="text-sm space-y-2">
                            <div className="font-semibold text-[#171717] flex">
                                <div className="w-full">
                                    {previewLang === 'EN'
                                        ? _cctvPolicyChange?.cctvDataProtectionTitleEn ||
                                          '-'
                                        : _cctvPolicyChange?.cctvDataProtectionTitleTh ||
                                          '-'}
                                </div>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                    <div className="font-semibold">
                                        {previewLang === 'EN'
                                            ? 'Show'
                                            : 'แสดงข้อมูล'}
                                    </div>
                                    <Switch
                                        checked={cctvDataProtectionIsDisplay}
                                        onChange={(checked) => {
                                            cctvPolicyChange.setFieldValue(
                                                'cctvDataProtectionIsDisplay',
                                                checked
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="whitespace-pre-wrap text-[#65707A] w-full">
                                {parse(
                                    `${
                                        previewLang === 'EN'
                                            ? _cctvPolicyChange?.cctvDataProtectionContentEn ||
                                              '-'
                                            : _cctvPolicyChange?.cctvDataProtectionContentTh ||
                                              '-'
                                    }`
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ModalConfirm
                open={openConfirm}
                handelClose={() => setOpenConfirm(false)}
                loading={props.loading_}
                handelOk={() => {
                    if (ref.current) ref.current.click();
                }}
                title={
                    <div className="flex-column items-center text-center space-y-2">
                        <div className="font-normal text-1xl">
                            {t('Publish this policy')}
                        </div>
                        <Tag
                            className="rounded-xl text-center bg-[#7B67FB]"
                            style={{ color: '#FFFFFF', borderColor: '#FFFFFF' }}
                        >
                            {t('Consent.PublishedVersion')}:{' '}
                            {_cctvPolicy?.latestPublishVersion
                                ? getNextVersion()
                                : '0001.0'}
                        </Tag>
                        <div className="font-normal text-[13px] text-[#65707A]">
                            {t('Consent.ModalDesPublish')}
                        </div>
                    </div>
                }
                text=""
            />
        </Form>
    );
};

export default StepPreview;

export const EditIcon = (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M18.988 2.01172L21.988 5.01172L19.701 7.29972L16.701 4.29972L18.988 2.01172ZM8 15.9997H11L18.287 8.71272L15.287 5.71272L8 12.9997V15.9997Z"
            fill="#7B67FB"
        />
        <path
            d="M19 19H8.158C8.132 19 8.105 19.01 8.079 19.01C8.046 19.01 8.013 19.001 7.979 19H5V5H11.847L13.847 3H5C3.897 3 3 3.896 3 5V19C3 20.104 3.897 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V10.332L19 12.332V19Z"
            fill="#7B67FB"
        />
    </svg>
);

export const svgNoImage = (
    <svg
        width={40}
        height={40}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx={20} cy={20} r={20} fill="#EDEEF9" />
        <g opacity="0.5">
            <path
                d="M27 11H13C11.8954 11 11 11.8954 11 13V27C11 28.1046 11.8954 29 13 29H27C28.1046 29 29 28.1046 29 27V13C29 11.8954 28.1046 11 27 11Z"
                stroke="#A9B2FF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.5 18C17.3284 18 18 17.3284 18 16.5C18 15.6716 17.3284 15 16.5 15C15.6716 15 15 15.6716 15 16.5C15 17.3284 15.6716 18 16.5 18Z"
                stroke="#A9B2FF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M29 23L24 18L13 29"
                stroke="#A9B2FF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    </svg>
);
